import type { ReactNode } from 'react'
import { cn } from '~/shared/lib/utils'

export function DetailList({ children, className }: { children: ReactNode; className?: string }) {
  return <dl className={cn('divide-y divide-border', className)}>{children}</dl>
}

export function DetailRow({
  label,
  action,
  children,
}: {
  label: string
  action?: ReactNode
  children: ReactNode
}) {
  return (
    <div className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-x-3 gap-y-1 py-3 first:pt-0 last:pb-0 sm:grid-cols-[8.5rem_minmax(0,1fr)_auto]">
      <dt className="col-start-1 text-muted-foreground text-sm sm:pt-1.5">{label}</dt>
      <dd className="col-span-2 col-start-1 row-start-2 min-w-0 text-sm sm:col-span-1 sm:col-start-2 sm:row-start-1 sm:pt-1.5">
        {children}
      </dd>
      {action ? (
        <div className="col-start-2 row-start-1 -my-1 justify-self-end sm:col-start-3">
          {action}
        </div>
      ) : null}
    </div>
  )
}
